import React, { CSSProperties } from 'react';
import { ChevronRight } from 'lucide-react';

interface ViewDetailsLinkProps {
  shareId: string;
}

export const ViewDetailsLink: React.FC<ViewDetailsLinkProps> = ({ shareId }) => {
  const handleClick = () => {
    window.location.href = `/event/${shareId}`;
  };

  return (
    <button
      style={styles.button}
      onClick={handleClick}
      type="button">
      <span style={styles.text}>View event</span>
      <ChevronRight size={20} color="white" />
    </button>
  );
};

const styles: Record<string, CSSProperties> = {
  button: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    border: '1px solid #ffffff',
    borderRadius: '20px',
    padding: '10px 16px',
    cursor: 'pointer',
    transition: 'opacity 0.2s',
  },
  text: {
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 'bold',
    textShadow: '0 1px 3px rgba(0, 0, 0, 0.75)',
  },
};
